<template>
  <div>
    <mediaPlayerCom class="mediaPlay"
                    :sourceUrl="sourceUrl"
                    :coverUrl="getCoverUrl"
                    ref="mediaPlayer"></mediaPlayerCom>

    <div class="title" :style="{backgroundImage:'url('+getBanerUrl+')'}"></div>
    <div class="pageTitle">详情介绍</div>

    <div class="theme">
      <div class="themeContent">
        <div class="themeTitle">直播主题</div>
        <p class="p1">{{ getTitle }}</p>
        <p class="p2">{{ getDate }}</p>
        <p class="p3">{{ getIntroduce }}</p>
      </div>
    </div>

    <div class="theme">
      <div class="themeContent3">
        <div class="themeTitle">{{ getOrgTitle }}</div>
        <div class="content3">
          <div style="width: 100%; height: 2rem;"></div>
          <orgUnit v-for="(item, index) in getOrg"
                   :key="index"
                   :ref="`r${index}`"
                   :info="item">
          </orgUnit>
          <div style="width: 100%; height: 2rem;"></div>
        </div>
      </div>
    </div>

    <div class="footer">

    </div>

  </div>
</template>

<script>
import mediaPlayerCom from "./mediaPlayerCom";
import orgUnit from "./item/orgUnit";
import {utils} from "../../network/utils";

export default {
  name: "liveDetailCom",
  components:{
    mediaPlayerCom,
    orgUnit
  },
  props: {
    sourceUrl:{
      type: String,
      default: ''
    },
    baseInfo: {
      type: Object,
      required: true
    },
  },
  computed:{
    //标题
    getTitle(){
      return this.baseInfo.title
    },
    //活动时间
    getDate(){
      return utils.date('Y年m月d日', this.baseInfo.startDate)
    },
    //直播简介
    getIntroduce(){
      return this.baseInfo.synopsis
    },
    //主办单位
    getOrg(){
      return this.baseInfo.organizers
    },
    //组织单位-标题名
    getOrgTitle(){
      if(this.baseInfo.id==17){
        return "“科学与中国”本场科普活动"
      }else{
        return "组织单位"
      }
    },
    getBanerUrl(){
      return this.baseInfo.mainImages[1]
    },
    getCoverUrl(){
      return this.baseInfo.mainImages[0]
    }
  },
  methods:{
    resetLiveSourceUrl(url, isLive){
      console.log("lidetail set url:"+url)
      this.$refs.mediaPlayer.resetLiveSourceUrl(url, isLive)
    }
  }
}
</script>

<style scoped>
.mediaPlay{
  width: 100%;
  height: 613px;
}

.title{
  /*margin-top: ;*/
  width: 1080px;
  height: 797px;
  /*background-image: url("../../assets/live/live20220519_baner.jpg");*/
  background-repeat: no-repeat;
  background-size: 1080px 797px;
  background-color: #646566;
}
.pageTitle {
  height: 150px;
  background: #0089e1;
  font-size: 50px;
  font-weight: bolder;
  color: #fff;
  line-height: 150px;
  text-align: center;
}


.theme {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.themeContent {
  width: 990px;
  min-height:100px;
  border-radius: 50px;
  border: 2px dashed #000;
  text-align: center;
  padding: 0 50px;
}
.themeContent .p1{
  margin-top: 75px;
  font-size: 50px;
  font-weight: bolder;
}
.themeContent .p2{
  font-size: 40px;
  margin-top: 30px;
}
.themeContent .p3{
  margin-top: 45px;
  margin-bottom: 45px;
  font-size: 40px;
  /*text-indent: 80px;*/
  text-align: left;
  line-height: 60px;
  white-space: pre-wrap;
}

.themeTitle {
  width: 580px;
  height: 100px;
  margin: auto;
  margin-top: -50px;
  line-height: 100px;
  border-radius: 20px;
  font-weight: bolder;
  font-size: 42px;
  color: #fff;
  background: #0089e1;
}

.themeContent3 {
  width: 990px;
  min-height: 300px;
  border-radius: 50px;
  border: 2px dashed #000;
  text-align: center;
  padding: 0 50px;
}

.content3 {
  position: relative;
  text-align: left;
  width: 900px;
  min-height: 100px;
  font-size: 40px;
}

.footer {
  width: 100%;
  height: 200px;
  /*background: #1d398a;*/
}
</style>